<template>
  <v-container>
    <v-card>
      <v-container>
        <v-card-title>ブランド名追加</v-card-title>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="brandName"
              label="ブランド名"
              :counter="30"
              v-validate="'required|max:30|min:1'"
              data-vv-name="brandName"
              :error-messages="errors.collect('brandName')"
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 align-self-center>
            <v-btn block color="success" dark @click="newBrands()">
              <v-icon dark>add</v-icon>追加
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <br />
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-container>
          <v-card-title>
            <span class="headline">ステータス設定</span>
          </v-card-title>
          <v-layout row wrap align-center>
            <v-flex>
              <v-select
                v-model="editingBrand.statusCode"
                :items="statuses"
                item-text="statusName"
                item-value="statusCode"
                label="ステータス"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">
              <v-icon dark>arrow_back</v-icon>戻る
            </v-btn>
            <v-btn color="blue darken-1" flat @click="save">
              <v-icon dark>save</v-icon>変更
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-card>
      <v-container>
        <v-card-title>ブランド一覧</v-card-title>
        <v-data-table
          :headers="headers"
          :items="brands"
          class="elevation-1"
          :custom-sort="customSort"
          hide-actions
        >
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.header.text }}</span>
              </template>
              <span>{{ props.header.text }}</span>
            </v-tooltip>
          </template>
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.brandId }}</td>
            <td class="text-xs-left">{{ props.item.brandName }}</td>
            <td class="text-xs-left">
              <a @click="editBrand(props.item)" v-if="props.item.status === '1'">有効</a>
              <a v-else>
                <a @click="editBrand(props.item)" v-if="props.item.status === '0'">無効</a>
              </a>
            </td>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <v-layout row wrap style="margin-top: 30px;">
      <v-flex xs12 sm12>
        <v-btn
          block
          color="#4C728A"
          dark
          :to="{ name: 'admin/new-admin-menu' }"
        >
          <v-icon color="black" left>home</v-icon>Home
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this
    thisObj.loading = true

    ServerApiCallService.brands()
      .then(response => {
        thisObj.brands = response.data.brands
        // 初期表示時の
        thisObj.loading = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,

      brandName: '',
      dialog: false,
      editedIndex: -1,
      statuses: [
        {
          statusName: '有効',
          statusCode: '1'
        },
        {
          statusName: '無効',
          statusCode: '0'
        }
      ],
      headers: [
        {
          text: 'ID',
          align: 'left',
          value: 'brandId'
        },
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'brandName',
          sortable: false
        },
        {
          text: 'ステータス',
          align: 'left',
          value: 'status',
          sortable: false
        }
      ],
      editingBrand: {},
      brands: []
    }
  },
  methods: {
    customSort(items, index, isDesc) {
      console.log('custom sort. brandId asc')
      items.sort((a, b) => {
        if (!isDesc) {
          return a[index] < b[index] ? -1 : 1
        } else {
          return b[index] < a[index] ? -1 : 1
        }
      })
      return items
    },
    newBrands() {
      console.log('new brands')
      let thisObj = this
      thisObj.loading2 = true

      // TODO 現状isDeletedがfalseの場合nullで飛ぶ
      let request = {
        brandName: this.brandName
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
        ServerApiCallService.brandsPost(request, sendContext)
          .then(response => {
            console.log('completed new stores')
            thisObj.loading2 = false

            thisObj.brand = response.data.brand
            thisObj.brands.push({
              brandId: thisObj.brand.brandId,
              brandName: thisObj.brand.brandName,
              status: thisObj.brand.status
            })
            thisObj.brandName = ''
            this.$validator.reset()
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      })
    },
    editBrand(item) {
      let thisObj = this
      console.log('open edit brand dialog')
      thisObj.brands.forEach(function(row) {
        if (row.brandId === item.brandId) {
          thisObj.statuses.forEach(function(status) {
            if (status.statusCode === item.status) {
              thisObj.editingBrandId = item.brandId
              thisObj.editingBrand = {
                statusName: status.statusName,
                statusCode: status.statusCode
              }
            }
          })
        }
      })
      this.dialog = true
    },
    save() {
      console.log('save dialog')
      let thisObj = this
      let sendRequest = {
        brandId: this.editingBrandId,
        status: this.editingBrand.statusCode
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      ServerApiCallService.brandsStatusPut(sendRequest, sendContext)
        .then(response => {
          if (response.data.result == '0') {
            console.log('success updating status')
            thisObj.brands.forEach(function(row) {
              if (row.brandId === thisObj.editingBrandId) {
                row.status = thisObj.editingBrand.statusCode
              }
            })
          }
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })

      // Object.assign(this.tableDatas[this.editedIndex], this.editedItem)
      this.close()
    },
    close() {
      this.dialog = false
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  }
}
</script>
